module.exports = __webpack_public_path__ + "assets/media/take-photo-cb960e8c.mp3";